import { Grid,Container,  Group, createStyles,Title,  Indicator, Avatar, rem, Tooltip, Modal, Button, } from '@mantine/core';
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useState } from 'react';
import { Logout, Video } from 'tabler-icons-react';

import GuestVideoView from './GuestVideoView';
import GuestToolsView from './GuestToolsView';

import deflag from '../app/images/austria-flag-icon.png' 
import intl from 'react-intl-universal';
import { set_userclick } from '../app/slice/mainslice';
const flagSrc = deflag;


dayjs.extend(duration);


const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  contback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  sysback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "70vw",
    position: "relative",
  },

  guestfooter: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
    backgroundColor: "#efefef",
    borderTop: `1px solid #ddd`,
    paddingLeft: `20px`,
    paddingRight: `20px`,
  },
  footerheadline: {
    fontWeight: 200,
    fontSize: "1.2em",
    color: "#00445E"
  },
  inside: {
    listStyleType: "none",
    paddingLeft: 0,
    margin: "0 0 20px;"
  },
  inside_li: {
    fontWeight: 400,
    fontSize: "89%",
    color: "#00445E",
  },
  paper: { 
    minWidth: 600,
  },
  padtop10: {
    paddingTop: `10px`,
  },
}));


const GuestInMeeting = () => {
    const dispatch = useDispatch()
    const { classes } = useStyles();
    const guest_joinlink = useSelector((state: any) => state.user.guest_joinlink)

    const [opened, setOpened] = useState(false);

    const help_audio_clicked = useSelector((state: any) => state.user.help_audio_clicked)

    useEffect(() => {
      if (!help_audio_clicked) {
        setOpened(true);    
      }
    },[help_audio_clicked]);

    const handleCloseAudioHelp = () => {
      setOpened(false);
      
    };
    
    const confirmCloseAudioHelp = () => {
      setOpened(false);
      dispatch(set_userclick())
    };


  return (
    <>
    <Container fluid > 
      <Grid >
          <Grid.Col span={9} > 
            {guest_joinlink !== undefined && help_audio_clicked &&
             <GuestVideoView />
            }
          </Grid.Col>
          <Grid.Col span={3}  > 
               <GuestToolsView />
         </Grid.Col>
     </Grid >
    </Container>  
    <Modal
        title=""
        opened={opened}
        onClose={handleCloseAudioHelp}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          {intl.get('WELCOME_MODAL_HEAD')}! 
          <hr />
          <Grid>
          <Grid.Col span={12}>
            <Button fullWidth color="green" onClick={confirmCloseAudioHelp}>{intl.get('WELCOME_MODAL_BUTTON')}</Button>
            </Grid.Col>
          </Grid>
      </Modal>   
    </> 
    );
  }
  
  export default GuestInMeeting;